export const checkItemsForAssetPresence = (itemList) => {
    let status = true;
    for(const item of itemList){
        if(item.inventory_item_id){
            status = false
        }
    }
    return status;
}